import React from 'react';
import { Query } from 'react-apollo';
import moment from 'moment';
import getOr from '~/util/getOr';

import Layout from '~/components/Layout/Layout';
import NotFound from '~/components/NotFound/NotFound';
import GraphQLMatchup from '~/components/GraphQLMatchup/GraphQLMatchup';
import StyledComponent from '~/components/Styled/Styled';

import GolfEvents from '~/graphql/queries/GolfEvents.graphql';
import css from './GraphQLMatchupContainer.scss';

class GraphQLMatchupContainer extends React.Component {
  render() {
    let query;
    let eventMapping;
    let variables = {};
    let after = this.props.after;

    if (this.props.league === 'pga' || this.props.league === 'lpga') {
      variables = {
        league: this.props.league,
        between: moment(this.props.after, 'YYYY-MM'),
        and: moment(this.props.after, 'YYYY-MM').add(1, 'month'),
      };
      query = GolfEvents;
      eventMapping = 'leagues.0.currentSeason.events.edges';
    }

    return (
      <Query query={query} variables={variables}>
        {({ data, loading, error, refetch }) => {
          if (loading) {
            return (
              <Layout>
                <div className={css.loadingState} />
              </Layout>
            );
          }
          if (error) return <NotFound />;
          const { schedule, inFuture } = this.props;

          if (getOr(data, eventMapping, []).length === 0) {
            variables = {
              league: this.props.league,
              between: moment(schedule[schedule.length - 1].id, 'YYYY-MM'),
              and: moment(schedule[schedule.length - 1].id, 'YYYY-MM').add(1, 'month'),
            };
            after = moment(schedule[schedule.length - 1].id).format('YYYY-MM');
            refetch(variables);
          }

          return (
            <GraphQLMatchup
              after={after}
              events={getOr(data, eventMapping, []).reverse()}
              league={this.props.league}
              schedule={schedule}
              inFuture={inFuture}
            />
          );
        }}
      </Query>
    );
  }
}

export default StyledComponent(GraphQLMatchupContainer, [css]);
